import $ from "jquery";
import CustomTagEditable from "libs/jquery-editable/modules/custom.tag.editable";

class TextEditable extends CustomTagEditable {
    element(settings, original) {
        const input = $('<input />');
        if (settings.width !== 'none') {
            input.width(settings.width);
        }
        if (settings.height !== 'none') {
            input.height(settings.height);
        }
        /* https://bugzilla.mozilla.org/show_bug.cgi?id=236791 */
        //input[0].setAttribute('autocomplete','off');
        input.attr('autocomplete', 'off');
        if (settings.preprocess) {
            settings.preprocess(input);
        } //ds
        $(this).append(input);
        return input;
    }

}

export default TextEditable;